import { useEffect } from "react"
import { useApiMutation } from "../hooks/useApiMutation"
import { getLs } from "../utils/localStorage"
import { getParamMetaData, paramIsValid } from "../utils/queryParams"
import { klaviyoIdentify } from "../utils/klaviyo"
import { SignupOrigin } from "./crmSignupHook"

type SignupInput = { value: string }
type SignupInputBool = { value: boolean }
export interface SignupInputs {
  firstName: SignupInput
  lastName: SignupInput
  email: SignupInput
  password: SignupInput
  allowMarketing: SignupInputBool
  signupOrigin: SignupOrigin
  nonce?: string
  state?: string
}

interface SignupPayload {
  firstName: string
  lastName: string
  email: string
  password: string
  allowMarketing: boolean
  type: string
  metadata: {
    key: string
    value: number | String
  }[]
  signupOrigin: string
  nonce?: string
  state?: string
}

export const useSignup = () => {
  const [
    signupUser,
    { loading: signupLoading, error: signupError, data: signupData },
  ] = useApiMutation("account", "CreateUser")

  const [
    freshdeskSignup,
    {
      loading: freshdeskSignupLoading,
      error: freshdeskSignupError,
      data: freshdeskSignupData,
    },
  ] = useApiMutation("account", "FreshdeskSignup")

  const signup = async (inputs: SignupInputs, freshdesk = false) => {
    const {
      firstName,
      lastName,
      email,
      password,
      allowMarketing,
      signupOrigin,
    } = inputs

    klaviyoIdentify(email.value)

    const metadata = await getParamMetaData()

    const input: SignupPayload = {
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      password: password.value,
      allowMarketing: allowMarketing.value,
      type: "USER",
      metadata,
      signupOrigin,
    }

    if (freshdesk) {
      input.nonce = inputs.nonce
      input.state = inputs.state
      freshdeskSignup({
        variables: {
          input,
        },
      })
    } else {
      signupUser({
        variables: {
          input,
        },
      })
    }
  }

  return [
    signup,
    signupLoading,
    signupError,
    signupData,
    freshdeskSignupLoading,
    freshdeskSignupError,
    freshdeskSignupData,
  ]
}
